// extracted by mini-css-extract-plugin
module.exports = {"content":"style_content__2vOAZ","consent":"style_consent__mvBji","buttons":"style_buttons__fcYsV"};